module.exports = __webpack_public_path__ + "static/media/help-bar.8878d4d4.png";